import React from 'react';
import { Link } from 'react-router-dom';
import { useCurrentLanguage, addLanguagePrefix } from '../utils/languageRouting';

/**
 * Language-aware Link component
 * Automatically adds language prefix to routes
 */
const LanguageLink = ({ to, children, state, ...props }) => {
  const currentLang = useCurrentLanguage();
  const pathWithLang = addLanguagePrefix(to, currentLang);
  
  return (
    <Link to={pathWithLang} state={state} {...props}>
      {children}
    </Link>
  );
};

export default LanguageLink;
